export default __webpack_public_path__ + "static/media/dictionary.8d1f9a62.png";